<template>
    
        <div class="modal-mask">
            <div class="modal-container">
                
                <div class="modal-header">
                    <div class="icon close" @click="$emit('close')"></div>
                    <slot name="header"></slot>
                </div>

                <div class="modal-body">
                    <slot name="body"></slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
            
        </div>
    

</template>
<script>

export default {
    name: 'ModalFrame',
    props: {
       
    },
    methods:{

    }
}
</script>
<style lang="scss"scoped>

.modal-mask {
    z-index: 9998;
    @include positions (fixed, 0, unset, unset, 0);
    @include size(100%, 100%);
    @include flexs-align();
    background-color: rgba(0, 0, 0, .4);
    transition: opacity .3s ease;
   
    .modal-container {
        width: 300px;
        height: 440px;
        background-color: #FFFFFF;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        @include flexs-direction();

        .modal-header {
            min-height: 40px;
            // background-color: #FFFFFF;
            // border-bottom: 1px solid #eaecf2;
            // padding: 1.6em .8em;
            @include flexs(center, center, column);
            // @include border-radius(.4rem, .4rem);
            position: relative;
            .icon.close {
                @include size(2.4rem, 2.4rem);
                @include positions(absolute, .4rem, .4rem, unset, unset);
                @include bg(12px);
                @include img('btn_close.png');
                // @include bg-icon("btn_close.png");
                opacity: .6;
            }

            .img{
                @include size(2.4rem, 2.4rem);
                @include bg(2.4rem);
                margin-bottom: 1rem;
            }

            *{
                color: lighten($color-point, 24%);
            }

            h2{
                color: $color-point;
                margin-bottom: 4px;
            }

        }

        .modal-body {
            flex: 1;
            overflow: auto;
            padding: 8px 16px;
        }

        .modal-footer {
            min-height: 40px;
        }
    }

}



</style>
